import { render } from "./signUp.vue?vue&type=template&id=6ef195a6"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__